module.exports = __webpack_public_path__ + "h5/img/becommendTitle.84525bc7.png";